import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/app/providers";

export const COOPERATIVE_U_BUILDING_PK = 53;

interface CooperativeURouteProps {
  children: React.ReactNode;
}

/** Routes /cooperativeU/* réservées au bâtiment Cooperative U (pk 53). */
const CooperativeURoute: React.FC<CooperativeURouteProps> = ({ children }) => {
  const { currentBuilding } = useAuth();
  const location = useLocation();

  if (Number(currentBuilding?.pk) !== COOPERATIVE_U_BUILDING_PK) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default CooperativeURoute;
